export default "__VITE_ASSET__BQLFV6bu__"